import React from "react";
import Morgage from "@icons-rf/shortcut/morgage.svg?react";
import UserPlus from "@icons-rf/shortcut/user-plus.svg?react";
import PlusIcon from "@icons-rf/shortcut/plus-maxcore.svg?react";
import Comission from "@icons-rf/shortcut/comission.svg?react";
import { Link, useLocation } from "react-router-dom";
import { C_PATH_ROUTES, C_PATH_ROUTER } from "../../../model/const/path.const";
import { Tooltip, Box } from "@mui/material";
import SelectTypeRealEstateModal from "../../modals/select-type-realestate-modal/SelectTypeRealestateModal";
import ENVIRONMENT_VAR from "../../../model/const/env/env.const";
import useUserIs from "../../../hooks/use-useris.hook";
import { ERolesCode } from "@/shared/models/enums/roles/roles-code.enum";
import { IconPlus } from "@tabler/icons-react";
import MxIcons from "@rf-l1/MxIcons";
import { useWidth } from "@/shared/hooks/use-width.hook";
import usePropertyCreateSelectType from "@rf/property/module/hooks/usePropertyCreateSelectType";
import MxButton2 from "@rf-l1/buttons/MxButton2";

interface ShortcutItem {
  Route: string | null;
  Icon: React.ReactElement;
  show: boolean;
  msg: string;
}

function ShortCut() {
  const { userIsNot, userIs } = useUserIs();
  const width = useWidth();
  const isMobile = ["xs", "sm"].includes(width);
  const { handleOpenModal } = usePropertyCreateSelectType();
  const { pathname } = useLocation();

  // Ocultar botón de creación en rutas de creación y borradores
  const HIDE_CREATE_REGEXES = [
    // /realestates/create
    new RegExp(
      `^${C_PATH_ROUTER.REALESTATE.ROOT}${C_PATH_ROUTER.REALESTATE.CREATE}$`
    ),
    // /realestates/project/create
    new RegExp(
      `^${C_PATH_ROUTER.REALESTATE.ROOT}${C_PATH_ROUTER.REALESTATE.PROJECT_CREATE}$`
    ),
    // // /realestates/drafts
    // new RegExp(
    //   `^${C_PATH_ROUTER.REALESTATE.ROOT}${C_PATH_ROUTER.PROPERTIES.DRAFT_LIST}$`
    // ),
    // /realestates/borrador/:idDraft/editar
    new RegExp(
      `^${
        C_PATH_ROUTER.REALESTATE.ROOT
      }${C_PATH_ROUTER.PROPERTIES.DRAFT_UPDATE.replace(":idDraft", "[^/]+")}$`
    ),
    // /realestates/project/borrador/:idDraft/editar
    new RegExp(
      `^${
        C_PATH_ROUTER.REALESTATE.ROOT
      }${C_PATH_ROUTER.PROPERTIES.DRAFT_PROJECT_UPDATE.replace(
        ":idDraft",
        "[^/]+"
      )}$`
    )
  ];
  const hideCreateButtons = HIDE_CREATE_REGEXES.some(rx => rx.test(pathname));
  const ITEMS: ShortcutItem[] = [
    {
      Route: null,
      Icon: (
        <MxButton2
          id="create-property-modal-shortcut-button"
          startIcon={
            <MxIcons size={16}>
              <IconPlus style={{ color: "white" }} size={16} />
            </MxIcons>
          }
          textColor="white"
          children="Crear inmueble"
          onClick={handleOpenModal}
          variant="contained"
        />
      ),
      show: !isMobile && !hideCreateButtons,
      msg: "Crear inmueble"
    },
    {
      Route: null,
      Icon: (
        <MxIcons
          onClick={handleOpenModal}
          sx={{
            display: "flex",
            alignItems: "flex-start",
            marginBottom: "3px"
          }}
          size={isMobile ? 28 : 32}
        >
          <PlusIcon />
        </MxIcons>
      ),
      show: isMobile && !hideCreateButtons,
      msg: "Crear inmueble"
    },
    {
      Route: C_PATH_ROUTES.USERS.CREATE,
      Icon: <UserPlus />,
      show: userIs(ERolesCode.SUPER_ADMIN, ERolesCode.ADMIN),
      msg: "Creación de agente"
    },
    {
      Route: ENVIRONMENT_VAR.MAXCORE_DOMAIN_V1 + "/commissions/create",
      Icon: <Comission />,
      show: true,
      msg: "Reporte de comisiones"
    },
    {
      Route: C_PATH_ROUTES.MORTGAGE_REFERRAL.CREATE,
      Icon: <Morgage />,
      show: true,
      msg: "Referimiento hipotecario"
    }
  ].filter(item => item.show);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "1rem",
        marginRight: "1.2rem",
        "& svg": {
          width: { xs: "25px", sm: "30px" },
          height: { xs: "25px", sm: "30px" },
          fill: "var(--m-color-blue-03)",
          color: "var(--m-color-blue-03)",
          cursor: "pointer",
          transition: "all 0.2s ease-in-out",
          "&:hover": {
            fill: "var(--m-color-blue-03)"
          }
        }
      }}
    >
      {ITEMS.map((item, index) => (
        <Tooltip title={item.msg} key={item.Route || index}>
          {!item.Route ? (
            <>{React.cloneElement(item.Icon as any, {})}</>
          ) : (
            <Link to={item.Route} key={item.Route}>
              {React.cloneElement(item.Icon as any, {})}
            </Link>
          )}
        </Tooltip>
      ))}
    </Box>
  );
}

export default ShortCut;
